import * as React from "react";
import { forwardRef } from "react";
const SvgIconMagnifyingGlass = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 18, height: 18, viewBox: "0 0 18 18", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M10.109 3A6.823 6.823 0 0 1 15.4 14.137l5.441 5.44-.981.981-5.441-5.44A6.826 6.826 0 1 1 10.109 3m0 1.365a5.462 5.462 0 1 0 5.462 5.462 5.45 5.45 0 0 0-5.462-5.462", transform: "translate(-3.281 -2.561)", fill: "#98a9bc" }));
const ForwardRef = forwardRef(SvgIconMagnifyingGlass);
export { ForwardRef as ReactComponent };
